import { useLocale, useTranslations } from 'next-intl';
import { routing } from '@/i18n/routing';
import { LocaleSwitcherSelect } from './lang-switcher-select';
import './styles.scss';
import { ArrowDown } from '@/frontend/components/ui/icons';

export default function LangSwitcher() {
  const t = useTranslations('LocaleSwitcher');
  const locale = useLocale();

  return (
    <label htmlFor="lang-switcher-select" className="language-switch">
      <LangSwitcherIcon />
      <LocaleSwitcherSelect defaultValue={locale}>
        {routing.locales.map((cur) => (
          <option key={cur} value={cur}>{t(cur)}</option>
        ))}
      </LocaleSwitcherSelect>
      <ArrowDown color="#fff" className="lang-arrow" />
    </label>
  );
};
LangSwitcher.displayName = 'LangSwitcher';

export { LangSwitcher };

const LangSwitcherIcon = ({ color = 'var(--lang-switcher__icon__color' }:{ color?: string; }) => {
  return (
    <svg width="26" height="26" viewBox="0 0 26 26" fill="none">
      <path stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" d="M13 1.75C15.9837 1.75 18.8452 2.93526 20.955 5.04505C23.0647 7.15483 24.25 10.0163 24.25 13C24.25 15.9837 23.0647 18.8452 20.955 20.955C18.8452 23.0647 15.9837 24.25 13 24.25H6.75C5.42392 24.25 4.15215 23.7232 3.21447 22.7855C2.27678 21.8479 1.75 20.5761 1.75 19.25V13C1.75 10.0163 2.93526 7.15483 5.04505 5.04505C7.15483 2.93526 10.0163 1.75 13 1.75Z" />
      <path stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" d="M16.75 11.75H9.25" />
      <path stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" d="M12.6875 15.5H9.25" />
    </svg>
  );
}